import api from '@/common/api';
import { str2Int, strArr2IntArr } from '@/common/utils';
import RouteKey from '@/common/RouteKey';
import MessageType from '@/components/common/message-box/MessageType';
import { backwardSupportValidate } from '@/common/ValidationUtils';
import { OptionMapper } from '@/common/OptionConstant';
import ErrorHandler from './ErrorHandler';
import Bubble from '../common/Bubble';
import tipConstant from '../data/TipConstant';
export default {
  name: 'AppCreator',
  components: {
    Bubble
  },
  data() {
    return {
      OptionMapper,
      tipConstant,
      newAppData: {
        name: '',
        description: '',
        platform: [],
        softtype: '',
        address: '',
        applytype: 2,
        joinway: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入应用名称',
          trigger: 'change'
        }, {
          max: 20,
          trigger: 'change'
        }, {
          validator: backwardSupportValidate,
          trigger: 'change'
        }],
        description: [{
          required: true,
          message: '请输入应用简介',
          trigger: 'change'
        }, {
          max: 600,
          trigger: 'change'
        }, {
          validator: backwardSupportValidate,
          trigger: 'change'
        }],
        platform: [{
          type: 'array',
          required: true,
          message: '请至少选择一种应用平台',
          trigger: 'change'
        }],
        softtype: [{
          required: true,
          message: '请选择应用类型',
          trigger: 'change'
        }],
        jointype: [{
          type: 'array',
          required: true,
          message: '请至少选择一种接入产品类型',
          trigger: 'change'
        }],
        joinway: [{
          required: true,
          message: '请选择业务主体',
          trigger: 'change'
        }],
        address: [{
          validator: backwardSupportValidate,
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    getSdkInfo() {
      if (this.$route.query.id == null || this.$route.query.id === 0) {
        return;
      }
      this.latestID = this.$route.query.id;
      this.$loader.post(api.ytpublic.GET_YTPUBLIC_INFO, {id: this.latestID}, this.ajaxErrorCallback).then((res) => {
        let platform = [];
        this.OptionMapper.APPLY_PLATFORM.forEach(ele => {
          let val = parseInt(ele.value);
          if ((val & res.platform) === val) {
            platform.push(ele.value);
          }
        });
        this.newAppData = {
          name: res.name,
          description: res.scene,
          platform: platform,
          softtype: res.softtype,
          applytype: res.applytype,
          joinway: res.scope,
          address: res.address
        };
      });
    },
    handleSubmitApp() {
      this.$refs.newAppData.validate(isValid => {
        if (isValid === false) {
          return;
        }
        let dataPart = this.newAppData;
        let data = {
          ...dataPart,
          platform: strArr2IntArr(dataPart.platform),
          softtype: str2Int(dataPart.softtype),
          joinway: str2Int(dataPart.joinway)
        };
        const loading = this.loading();
        this.$loader.upload(api.ytpublic.CREATE_YTPUBLIC, data, this.ajaxErrorCallback).then(() => {
          this.$alert('公有云服务已提交审核', null, MessageType.SUCCESS).then(() => {
            loading.close();
            this.$router.transfer(RouteKey.OPEN_APP_DISPLAY);
          });
        }).finally(() => {
          loading.close();
        });
      });
    }
  },
  created() {
    this.ajaxErrorCallback = ErrorHandler.ajaxErrorCallback(this);
    this.getSdkInfo();
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/application/panels/js/AppCreator.js